import { QueryRenderer } from 'react-relay';
import { object, func } from 'prop-types';
import CookieNotification from '../CookieNotification/CookieNotification';
import { getUserSessionCountryCode } from 'dibs-regional-info/exports/regionalInfoHelpers';

const CookieNotificationRenderer = ({ environment, query }) => {
    return (
        <QueryRenderer
            environment={environment}
            query={query}
            variables={{ userCountryCode: getUserSessionCountryCode() }}
            render={({ error, props: rendererProps }) => {
                if (error) {
                    return null;
                } else if (rendererProps) {
                    return <CookieNotification {...rendererProps} />;
                } else {
                    return null;
                }
            }}
        />
    );
};

CookieNotificationRenderer.propTypes = {
    environment: object,
    query: func,
};

export default CookieNotificationRenderer;
